/**
 * @generated SignedSource<<f42c967350b416fe6992ace238199479>>
 * @relayHash c281ec4852c51aa98909ca96b21c3af6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ed173ef8dd2ec22305ea74c10ab7eeb6d3ffd84b11c92ea1fc3368447b5c2a55

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

import isSavedViewsBoardColumnSettingsEnabled_provider from '@atlassian/jira-relay-provider/src/saved-views-board-column-settings.relayprovider';
import withFiltersAndColumnSettings_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-and-column-settings.relayprovider';
import withFilters_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-setting.relayprovider';
import withSelectedWorkflow_provider from '@atlassian/jira-relay-provider/src/saved-views-board-selected-workflow-setting.relayprovider';
import isSaveResetViewEnabled_provider from '@atlassian/jira-relay-provider/src/sv-230-save-revert-board-view-settings.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ed173ef8dd2ec22305ea74c10ab7eeb6d3ffd84b11c92ea1fc3368447b5c2a55",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardcolumnsettingsrelayprovider": isSavedViewsBoardColumnSettingsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfiltersettingrelayprovider": withFilters_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardselectedworkflowsettingrelayprovider": withSelectedWorkflow_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfilterandcolumnsettingsrelayprovider": withFiltersAndColumnSettings_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsv230saverevertboardviewsettingsrelayprovider": isSaveResetViewEnabled_provider
    }
  }
};

export default node;
